import {GoogleApiWrapper} from 'google-maps-react';
import { GOOGLE_API_KEY } from '../../settings';

export default GoogleApiWrapper({
    apiKey: GOOGLE_API_KEY
})
